export default __webpack_public_path__ + "images/0xdc301622e621166bd8e82f2ca0a26c13ad0be355.png";